const apiUrl = 'https://capstone-api-ck6i.onrender.com'

export default apiUrl
